/** Admin API for `special_product_pricing_tiers` (UI: "Special product pricing tiers"). */
import apiClient from '../api/apiClient';

const BASE = '/api/v1/admin/special-product-pricing-tiers';

const specialProductPricingTiersService = {
  /**
   * @param {string} productId
   * @param {string} pricingGroupId
   * @param {{ userId?: string, partnerId?: string }} subject - exactly one of userId or partnerId
   */
  async list(productId, pricingGroupId, subject) {
    const params = { productId, pricingGroupId };
    if (subject.userId) params.userId = subject.userId;
    if (subject.partnerId) params.partnerId = subject.partnerId;
    const response = await apiClient.get(BASE, { params });
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load special product tiers');
    }
    const list = body?.data?.tiers;
    return { tiers: Array.isArray(list) ? list : [] };
  },

  /**
   * @param {object} params
   */
  async resolve(params) {
    const response = await apiClient.get(`${BASE}/resolve`, { params });
    return response?.data;
  },

  async get(uuid) {
    const response = await apiClient.get(`${BASE}/${uuid}`);
    const body = response?.data;
    if (body?.success === false) {
      throw new Error(typeof body?.message === 'string' ? body.message : 'Failed to load tier');
    }
    return body?.data?.tier ?? null;
  },

  async create(payload) {
    const response = await apiClient.post(BASE, payload);
    return response?.data;
  },

  async update(uuid, payload) {
    const response = await apiClient.patch(`${BASE}/${uuid}`, payload);
    return response?.data;
  },

  async remove(uuid) {
    const response = await apiClient.delete(`${BASE}/${uuid}`);
    return response?.data;
  },
};

export default specialProductPricingTiersService;
